import script from "./OfflineArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfflineArea.vue?vue&type=script&setup=true&lang=ts"

import "./OfflineArea.vue?vue&type=style&index=0&id=4c961ab4&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c961ab4"]])

export default __exports__